import React from 'react';
import FormSection from '../FormSection';
import { StepNumberIcon } from '../../icons';
import type { ShippingAddressFormProps } from './types/shipping-address.types';
import { useShippingAddress } from './hooks/useShippingAddress';
import ZipCodeField from './components/ZipCodeField';
import AddressFields from './components/AddressFields';
import ShippingButtons from './components/ShippingButtons';

const ShippingAddressForm: React.FC<ShippingAddressFormProps> = (props) => {
  const {
    formData,
    errors,
    isFetchingCep,
    isCepValidAndFound,
    isZipCodeValid,
    isStreetValid,
    isNumberValid,
    isNeighborhoodValid,
    handleChange,
    handleZipCodeChange,
    handleSubmit,
  } = useShippingAddress(props);

  return (
    <div className="container mx-auto max-w-2xl">
      <FormSection 
        title="Endereço de Entrega" 
        icon={<StepNumberIcon displayNumber={2} />}
      >
        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="desc mb20">
            Cadastre ou selecione um endereço
          </div>

          <ZipCodeField
            value={formData.zipCode}
            error={errors.zipCode}
            isFetching={isFetchingCep}
            isValid={isZipCodeValid}
            onChange={handleZipCodeChange}
            city={formData.city}
            state={formData.state}
          />

          <AddressFields
            formData={formData}
            errors={errors}
            isCepValidAndFound={isCepValidAndFound}
            isStreetValid={isStreetValid}
            isNumberValid={isNumberValid}
            isNeighborhoodValid={isNeighborhoodValid}
            onChange={handleChange}
          />

          <ShippingButtons
          />
        </form>
      </FormSection>
    </div>
  );
};

export default ShippingAddressForm; 